export default {
  title: 'Gedrukte bon',
  form: {
    is_service_fee_hidden_on_receipt: {
      label: 'Servicekosten verbergen op bon',
    },
    is_price_section_hidden_on_receipt: {
      label: 'Prijssectie verbergen op bon',
    },
    is_modifier_group_hidden_on_receipt: {
      label: 'Namen van modificatiegroepen verbergen op bon',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
  },
};
